import { Link } from 'react-router-dom'

import { paths } from 'src/config/paths'
import { cn } from 'src/lib/utils'

import { Logo } from '../icons/logos/logo'

interface LogoLinkProps {
  to: string
  logoClassName?: string
  showCircleR?: boolean
}

export default function LogoLink({ to = paths.root.path, logoClassName, showCircleR = true }: LogoLinkProps) {
  return (
    <Link to={to}>
      <Logo showCircleR={showCircleR} className={cn('h-[28px] w-[136px]', logoClassName)} />
    </Link>
  )
}
